import { render, staticRenderFns } from "./rechgPopups.vue?vue&type=template&id=3379da94&scoped=true&"
import script from "./rechgPopups.vue?vue&type=script&lang=js&"
export * from "./rechgPopups.vue?vue&type=script&lang=js&"
import style0 from "./rechgPopups.vue?vue&type=style&index=0&id=3379da94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3379da94",
  null
  
)

export default component.exports